export const STAR_MAPPING_URL = '/data/star-mapping.json';
export const DATA_BASE_URL = '/data';
export const CITY_ZOOM_THRESHOLD = 3;
export const CONTENT_BASE_PATH = `${DATA_BASE_URL}/content`;
export const BOUNDARY_BASE_PATH = `${DATA_BASE_URL}/nations/boundaries`;
export const CONSTELLATION_LINES_URL = `${DATA_BASE_URL}/constellations/lines.json`;
export const BOUNDARY_STYLE = {
	color: 'rgba(22, 12, 38, 0.95)',
	weight: 2.25,
	opacity: 0.95,
	fillColor: 'rgba(187, 123, 255, 0.28)',
	fillOpacity: 0.08,
	lineJoin: 'round',
	lineCap: 'round',
	className: 'map-boundary map-boundary--core'
};
export const BOUNDARY_HALO_STYLE = {
	color: 'rgba(251, 247, 255, 0.85)',
	weight: 5.4,
	opacity: 0.75,
	fillColor: 'transparent',
	fillOpacity: 0,
	lineJoin: 'round',
	lineCap: 'round',
	className: 'map-boundary map-boundary--halo'
};
export const BOUNDARY_HANDLE_PANE = 'boundaryHandles';
export const MAP_MODES = {
	NORMAL: 'normal',
	STAR: 'star',
	EDIT: 'edit'
};
export const MODE_KEYMAP = {
	n: MAP_MODES.NORMAL,
	s: MAP_MODES.STAR,
	e: MAP_MODES.EDIT
};
export const DEFAULT_LORE_HTML =
	'<h1 class="info-panel__title">Mortum Caelum</h1>' +
	'<div class="info-panel__content">' +
	'<p><strong>The Hierophant</strong> is my ongoing fantasy saga, built in public through notes, tools, and dispatches that share the work of worldbuilding.</p>' +
	'<p><strong>Mortum Caelum</strong> is the living world behind those stories&mdash;a mapped web of nations, calendars, and clandestine orders ready for exploration.</p>' +
	'<p>Select a nation or city to open its lore, or <a href="/" target="_blank" rel="noopener">return to The Hierophant World</a> for the wider project.</p>' +
	'</div>';
